module.exports = __webpack_public_path__ + "static/media/logo.09f6df92.jpg";